import { EventLocationType, EVENT_VISIBILITY_DISPLAY } from "@mimber/schema"
import type { EventVisibility } from "@mimber/schema"

export const LOCATION_TYPE_OPTIONS = [
  { label: "In Person", value: EventLocationType.PHYSICAL },
  { label: "Virtual", value: EventLocationType.VIRTUAL },
  { label: "Hybrid", value: EventLocationType.HYBRID },
]

export const VISIBILITY_OPTIONS = (
  Object.entries(EVENT_VISIBILITY_DISPLAY) as [
    EventVisibility,
    { label: string; color: string },
  ][]
).map(([value, { label }]) => ({ value, label }))
